import { LogDnaComponent } from './components';

export const LogDna = LogDnaComponent;

export { LogDnaStackTraceService } from './services';
